import React from 'react'

import { ContentCardSection } from '../../components/ContentCardSection'
import { RastreamentosModel } from '../model-rastreamentos'
import { RastreamentosListCard } from './RastreamentosListCard'

export interface RastreamentosCardProps {
  rastreamentos: RastreamentosModel[]
  loading: boolean
  canRender: boolean
}

export function RastreamentosCard(props: Readonly<RastreamentosCardProps>) {
  const { rastreamentos, loading, canRender } = props

  return (
    <ContentCardSection isLoading={loading} messageLoading='Carregando dados dos rastreamentos' canRender={canRender}>
      <RastreamentosListCard rastreamentos={rastreamentos} />
    </ContentCardSection>
  )
}
